import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";
import ErrorBoundary from "@/components/ErrorBoundary";
import Login from "@/pages/Login";
import Setup from "@/pages/Setup";
import AppLayout from "@/components/AppLayout";
import Dashboard from "@/pages/Dashboard";
import Services from "@/pages/Services";
import Professionals from "@/pages/Professionals";
import Clients from "@/pages/Clients";
import Appointments from "@/pages/Appointments";
import Reports from "@/pages/Reports";
import Settings from "@/pages/Settings";
import Users from "@/pages/Users";
import PlatformAdmin from "@/pages/PlatformAdmin";
import Invoices from "@/pages/Invoices";
import PublicBooking from "@/pages/PublicBooking";
import ClientLogin from "@/pages/ClientLogin";
import ClientRegister from "@/pages/ClientRegister";
import SalesLanding from "@/pages/SalesLanding";
import ChecklistPage from "@/pages/ChecklistPage";
import ChecklistSignPage from "@/pages/ChecklistSignPage";
import TimeBlocks from "@/pages/TimeBlocks";
import { getToken } from "@/lib/api";

const RequireAuth = ({ children }) => (getToken() ? children : <Navigate to="/login" replace />);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ErrorBoundary>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/setup" element={<Setup />} />
          <Route path="/vendas" element={<SalesLanding />} />
          <Route path="/agendar/login" element={<ClientLogin />} />
          <Route path="/agendar/registrar" element={<ClientRegister />} />
          <Route path="/agendar/:slug" element={<PublicBooking />} />
          <Route path="/agendar" element={<PublicBooking />} />
          {/* Remote client signature (SMS/WhatsApp link) — token-based */}
          <Route path="/assinar/:token" element={<ChecklistSignPage />} />
          {/* Client-facing checklist view (read via client_token) */}
          <Route path="/agendar/checklist/:aid" element={<ChecklistPage mode="client" />} />
          <Route path="/" element={<RequireAuth><AppLayout /></RequireAuth>}>
            <Route index element={<Dashboard />} />
            <Route path="servicos" element={<Services />} />
            <Route path="profissionais" element={<Professionals />} />
            <Route path="bloqueios" element={<TimeBlocks />} />
            <Route path="clientes" element={<Clients />} />
            <Route path="agenda" element={<Appointments />} />
            <Route path="relatorios" element={<Reports />} />
            <Route path="configuracoes" element={<Settings />} />
            <Route path="usuarios" element={<Users />} />
            <Route path="franquias" element={<PlatformAdmin />} />
            <Route path="faturas" element={<Invoices />} />
          </Route>
          {/* Admin-authenticated checklist page (uses admin token) */}
          <Route path="/checklist/:aid" element={<RequireAuth><ChecklistPage mode="admin" /></RequireAuth>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        </ErrorBoundary>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </div>
  );
}

export default App;
